import { session } from '@bitstopco/bitstop-theme';

import { getOperatorIdFromToken } from '@/helpers/auth0Session';

/**
 * Get Operator ID from JWT Token
 *
 * Reads whichever token issued the session: ergot nests it under `user`, Auth0
 * carries it as a namespaced claim.
 *
 * @return {*} {string}
 */
export const getOperatorId = () => {
  try {
    return getOperatorIdFromToken(session.getValue()) ?? '';
  } catch {
    return '';
  }
};
